import type { SlashCommand } from "./types";

export type { SlashCommand };

/**
 * Resolves a slash command from user input.
 * Returns the expanded prompt, or null if no command matched.
 */
export function resolveSlashCommand(
  input: string,
  commands: SlashCommand[]
): string | null {
  const trimmed = input.trim();
  if (!trimmed.startsWith("/")) return null;

  const parts = trimmed.split(/\s+/);
  const commandName = parts[0]; // e.g., "/summarize"
  const userInput = parts.slice(1).join(" ");

  const command = commands.find((c) => c.name === commandName);
  if (!command) return null;

  return command.promptTemplate.replace("{input}", userInput).trim();
}
